import { Reducer } from '@reduxjs/toolkit'
import api from '../../../services/axios'
import {
    AgendaTypes,
    AuthState,
    LoginTypes,
    RefreshTokenTypes,
    RegisterTypes,
    UserCerqTypes,
} from './types'

// toolkit
// import { createSlice } from '@reduxjs/toolkit'

const initialState: AuthState = {
    isLoggedIn: false,
    token: '',
    refreshToken: '',
    user: {
        // username: '',
        email: '',
        empresa: '',
        verificationC: false,
        isDocumentValid: false,
        cnpj_cpf: '',
        solicitouAgendaHoje: true,
    },
    registerError: false,
    isLoading: false,
}

const reducer: Reducer<AuthState> = (state = initialState, action) => {
    switch (action.type) {
        case LoginTypes.LOGIN_REQUEST: {
            return state
        }

        case LoginTypes.LOGIN_SUCCESS: {
            const newState = { ...state }
            newState.token = action.payload.token
            newState.refreshToken = action.payload.refreshToken
            newState.isLoggedIn = true
            newState.user = action.payload.user
            return newState
        }

        case LoginTypes.LOGIN_FAILURE: {
            const newState = { ...initialState }
            delete api.defaults.headers.common['Authorization']
            return newState
        }

        case RegisterTypes.REGISTER_REQUEST: {
            // Estratégia de loading?
            return {
                ...state,
                isLoading: true,
            }
        }

        case RegisterTypes.REGISTER_SUCCESS: {
            // Estratégia de loading?
            return {
                ...state,
                isLoading: false,
                registerError: false,
            }
        }

        case RegisterTypes.REGISTER_FAILURE: {
            // Estratégia de loading?
            return {
                ...state,
                isLoading: false,
                registerError: true,
            }
        }

        case UserCerqTypes.SUCCESS_USER_OPT_IN: {
            const newState = { ...state.user }
            newState.verificationC = action.payload
            return {
                ...state,
                user: { ...newState },
            }
        }

        case UserCerqTypes.FAILURE_USER_OPT_IN: {
            const newState = { ...state.user }
            newState.verificationC = false
            return {
                ...state,
                user: { ...newState },
            }
        }

        case RefreshTokenTypes.REFRESH_TOKEN: {
            const newState = { ...state }
            newState.token = action.payload.token
            newState.refreshToken = action.payload.refreshToken
            return newState
        }

        case AgendaTypes.AGENDA_RESPONSE: {
            const newState = { ...state.user }
            newState.solicitouAgendaHoje = action.payload.solicitouAgendaHoje
            return {
                ...state,
                user: { ...newState },
            }
        }

        default:
            return state
    }
}

// const authSlice = createSlice({
//     name: 'auth',
//     initialState: initialState,
//     reducers: {
//         loginRequest(state, action) {
//             return state
//         },
//         loginSucess(state, action) {
//             const newState = { ...state }
//             newState.token = action.payload.token
//             newState.isLoggedIn = true
//             newState.user = action.payload.user
//             return newState
//         },
//         loginFailure(state, action) {
//             const newState = { ...initialState }
//             delete axios.defaults.headers.common['Authorization']
//             return newState
//         }
//     }
// })

export default reducer
